import utils from 'utils';

import {ReportChart, UiMessage} from '@components/export';
import {useLabel} from '@/hooks/export';

import {Moment} from 'moment';

export const ReportDetail = (props: {
    productName?: string,
    currentDate: Moment,
    loading: boolean,
    reportData: apiReportData,
}) => {
    const label = useLabel();

    const handle = {
        getDateTitle(date) {
            const format = 'Do MMMM YYYY';

            return date.startOf('month').format(format) + ' - ' + date.endOf('month').format(format);
        },
    };

    return <div className={cmpClass}>
        {
            props.loading ?
                <UiMessage type={'loading'} text={label.loading} /> :
                props.reportData && props.currentDate ?
                    <>
                        <div className={classMap.title}>
                            <div className={classMap.titleRow}>
                                <i className={'iconfas-chart'}></i>
                                <span>{label.report}:</span>
                                <span>{handle.getDateTitle(props.currentDate)}</span>
                            </div>
                            <div className={classMap.titleRow}>
                                <span>{props.productName}</span>
                            </div>
                        </div>
                        <div className={classMap.chart}>
                            <ReportChart reportData={props.reportData} selectedProductName={props.productName}/>
                        </div>
                    </> :
                    <UiMessage type={'interaction'} text={label.selectMonthAndYear} />
        }
    </div>;
};

const cmpClass = 'report-detail';
const classMap = utils.generateClassMap(cmpClass, {
    title: 'title',
    titleRow: 'title-row',
    chart: 'chart',
});
